<template>
  <main>
    <DetailArchive />
  </main>
</template>

<script>
const DetailArchive = () => import('@/components/Archive/Detail')

export default {
  components: {
    DetailArchive
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
</style>
